import React, { useState, useEffect, Fragment } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import * as actions from '../../store/actions/actions';
import Card from '../../components/Card/Card';
import CountryPicker from '../CountryPicker/CountryPicker';
import classes from './Stats.css';

const Stats = (props) => {
	
  const [countryName, setCountryName] = useState("USA");

  const { stats } = props;
  
  useEffect(() => {
       props.onGetStatsAsyc(props.stats.country || 'USA');

  }, [])

  const handleChange = (e) => {
  	const { value, name } = e.target;
    props.onGetStatsAsyc(value);
  }
 console.log("render", props.error,props.loading);
  return (
       <Fragment>
        {props.loading && <div className={classes.Spinner}></div>}
        <div className={classes.Stats}>
         	   { props.error && <p className={classes.Error}> { props.error.message }</p>}
             { props.stats && Object.keys(props.stats).length > 0 && <Card countryStats={stats}/> }
  	         <CountryPicker handleSelectChange={handleChange} selected={props.stats.country}/>
        </div>
       </Fragment>
	)
}

const mapStateToProps = state => {
  return {
  	stats: state.statsReducer.stats,
  	loading: state.statsReducer.loading,
    error: state.statsReducer.error
  }
}

const mapDispatchToProps = dispatch => {
	return {
		onGetStatsAsyc: (value) => dispatch(actions.getStatsAsyc(value)),
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(Stats);


// WEBPACK FOOTER //
// ./src/containers/Stats/Stats.js